import ReactGA from "react-ga4";

const isAnalyticsEnabled = () => import.meta.env.PROD && ReactGA.isInitialized;

export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  if (isAnalyticsEnabled()) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  } else {
    console.log(`[Analytics Event (Dev)] Category: ${category}, Action: ${action}, Label: ${label || 'N/A'}, Value: ${value || 'N/A'}`);
  }
};
